import { getAuthAxiosBackend } from "../helpers/axios"

class SkillServices{

    getByPersonId(personId){
        return getAuthAxiosBackend().get('PersonSkills/getSkillsByPersonId/' + personId)
    }

    add(data){
        return getAuthAxiosBackend().post('PersonSkills/addOneSkillToPerson', data)
    }

    update(data){
        return getAuthAxiosBackend().put('PersonSkills/updatePersonSkills', data)
    }

    delete(data){
        return getAuthAxiosBackend().delete('PersonSkills/removeSkillFromPerson', { data })
    }
}

export default new SkillServices()